<script setup>
import { ref, computed, watch } from 'vue';
import { restrictedWords } from '/app/composables/challenge-create-flow';

const props = defineProps({
    modelValue: {
        type: String,
        default: '',
    },
    challenge: {
        type: Object,
        default: () => ({}),
    },
    words: {
        type: Array,
        default: () => restrictedWords,
    },
});

const emit = defineEmits(['update:valid']);

const shouldContainWords = ref(false);

const isValidQuestionTitle = computed(() =>
    props.words.some(word => (props.modelValue || '').match(new RegExp(word, 'i'))),
);

watch(isValidQuestionTitle, (valid) => {
    if (shouldContainWords.value && valid) {
        emit('update:valid', valid);
    }
});

watch(shouldContainWords, () => {
    emit('update:valid', isValidQuestionTitle.value);
});

function notify() {
    shouldContainWords.value = false;
    if (!isValidQuestionTitle.value) {
        setTimeout(() => {
            shouldContainWords.value = true;
        }, 100);
    }
}

function isSelected(word) {
    return String(props.challenge.question_title).match(new RegExp(word, 'i'));
}

defineExpose({ notify });
</script>


<template>
    <div>
        <p class="block w-full text-base text-black mb-2">
            Consider using these words in your question... This site is not for "<b>good advice</b>" — it is for generating innovative thinking:
        </p>
        <div class="flex flex-wrap gap-2" :class="{ 'animate-shake': shouldContainWords }">
            <span
                v-for="(word, i) of words" :key="i"
                class="px-3 py-1 rounded-md leading-tight font-body"
                :class="
                    isSelected(word)
                    ? 'bg-blue-600 text-white'
                    : 'bg-blue-200 text-blue-800'
                ">
                {{ word }}
            </span>
        </div>
    </div>
</template>
